"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../../util");

var helpStyle = function helpStyle(_ref) {
  var validateStatus = _ref.validateStatus,
      theme = _ref.theme;
  return /*#__PURE__*/(0, _react.css)("display:flex;justify-content:flex-end;margin-top:", (0, _util.rem)(4), ";line-height:", (0, _util.rem)(24), ";svg{margin-right:", (0, _util.rem)(4), ";width:", (0, _util.rem)(24), ";height:", (0, _util.rem)(24), ";flex-shrink:0;}", validateStatus === 'success' && /*#__PURE__*/(0, _react.css)("color:", theme.color.primary.positive, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:helpStyle;")), " ", validateStatus === 'error' && /*#__PURE__*/(0, _react.css)("color:", theme.color.primary.negative, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:helpStyle;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:helpStyle;"));
};

var styles = {
  helpStyle: helpStyle
};
exports.styles = styles;
//# sourceMappingURL=Help.styles.js.map